import React, { Component } from 'react';

import SpreadsheetLayout from './SpreadsheetLayout';
import Icon from '../../common/components/Icon';

// Always display extra rows/cols to prevent the UI from interfering with spreadsheet
const MIN_COLS = 20;
const MIN_ROWS = 20;
const EXTRA = 3;

class MKSSpreadsheet extends Component {
	render() {
		const { roles, lockings, ...props } = this.props;

		const cols = Math.max(MIN_COLS, roles.length) + EXTRA;
		const rows = Math.max(MIN_ROWS, lockings.length) + EXTRA;

		return (
			<SpreadsheetLayout
				{...props}
				columnsNumber={cols}
				rowsNumber={rows}
				renderCell={this.renderRight}
			/>
		);
	}

	renderRight = (rowIndex, columnIndex) => {
		const { roles, lockings } = this.props;

		if (roles.length == 0 || lockings.length == 0) return null;

		const isEmptyCell =
			rowIndex > lockings.length - 1 || columnIndex > roles.length - 1;

		if (isEmptyCell) return null;

		const locking = lockings[rowIndex];
		const role = roles[columnIndex];

		const hasRight = role.lockings.find(
			lockingId => lockingId === locking.locking_id
		);

		// Render nothing if group, check icon (has rights) or cross icon (hasn't right)
		return (
			<div className="mks-spreadsheet__cell">
				{locking.is_locking && <Right hasRight={hasRight} />}
			</div>
		);
	};
}

const Right = ({ hasRight }) =>
	hasRight ? <Icon icon="check-validate" /> : <Icon icon="lock" />;

export default MKSSpreadsheet;



// WEBPACK FOOTER //
// ./src/js/PatternDuplication/SpreadsheetLayout/MKSSpreadsheet.js